import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './organization-configuration.reducer';

export const OrganizationConfigurationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const organizationConfigurationEntity = useAppSelector(state => state.organizationConfiguration.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="organizationConfigurationDetailsHeading">
          <Translate contentKey="tycheApp.organizationConfiguration.detail.title">OrganizationConfiguration</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{organizationConfigurationEntity.id}</dd>
          <dt>
            <span id="apiKey">
              <Translate contentKey="tycheApp.organizationConfiguration.apiKey">Api Key</Translate>
            </span>
          </dt>
          <dd>{organizationConfigurationEntity.apiKey}</dd>
          <dt>
            <span id="apiSecret">
              <Translate contentKey="tycheApp.organizationConfiguration.apiSecret">Api Secret</Translate>
            </span>
          </dt>
          <dd>{organizationConfigurationEntity.apiSecret}</dd>
          <dt>
            <span id="callbackUrl">
              <Translate contentKey="tycheApp.organizationConfiguration.callbackUrl">Callback Url</Translate>
            </span>
          </dt>
          <dd>{organizationConfigurationEntity.callbackUrl}</dd>
          <dt>
            <Translate contentKey="tycheApp.organizationConfiguration.organization">Organization</Translate>
          </dt>
          <dd>{organizationConfigurationEntity.organization ? organizationConfigurationEntity.organization.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/organization-configuration" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/organization-configuration/${organizationConfigurationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrganizationConfigurationDetail;
